<script setup lang="ts">
import LaunchPad from "./LaunchPad.vue";

const launchItems = [
  { text: "Interventions", icon: "mdi-wrench", route: "/intervention-templates" },
  { text: "Produits", icon: "mdi-wrench", route: "/products" },
  { text: "Templates", icon: "mdi-wrench", route: "/intervention-templates" },
  { text: "Reporting", icon: "mdi-wrench", route: "/reporting" },
  { text: "Paramètres", icon: "mdi-cog", route: "/settings" },
  { text: "Utilisateurs", icon: "mdi-account", route: "/users" },
];
</script>

<template>
  <LaunchPad :items="launchItems" />
</template>
